import KendoSwitchMixin from './KendoSwitchMixin'

export default {
    name: 'kendo-switch',
    mixins: [ KendoSwitchMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/index.js